import styled from 'styled-components';

export const ModalConditionSummaryStyled = styled.div`
  .applied-item-title {
    min-width: 65px;
    &.text--critical .Polaris-Text--headingSm {
      color: var(--p-color-text-critical);
    }
    &.no-width {
      min-width: 0;
    }
  }
  .applied-item-info {
    max-width: calc(100% - 65px);
    &.no-padding-left > ol {
      padding-left: 0;
    }
  }
  .Polaris-List__Item {
    word-wrap: break-word;
  }
  .message-container {
    display: flex;
    margin-left: 13px;
    margin-bottom: 0.25rem;
    gap: 6px;
  }
  hr {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;
